import {useState, useEffect} from 'react';
import {Row, Col, Form} from 'react-bootstrap';
import {useForm, useWatch, Controller} from 'react-hook-form';
import {compose} from '../../lib/compose';
import withAlerts from '../../lib/withAlerts';
import DeleteConfirmModal from '../deleteConfirmModal';
import {useAccountMutations} from './accountMutations';
import {useFeatureContext} from '../../lib/context/featureContext';
import {useCustomerContext} from '../../lib/context/customerContext';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleCheck, faCircleXmark} from '@fortawesome/pro-solid-svg-icons';
import {faCircle} from '@fortawesome/pro-solid-svg-icons';
import variables from '../../styles/_variables.module.scss';
import ConfirmFeatureToggle from './confirmFeatureToggle';

export const EdgeLockToggle = ({alerts = {}}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const {feature_customer_edge_lock} = useFeatureContext();
  const {hasPermission} = useCustomerContext();
  const {success, error} = alerts;
  
  const {featureToggle} = useAccountMutations();

  // RBAC: FEATURE_EDIT has no listed treatment - applying the default rule
  // (FEATURE_VIEW present, which gates the whole Features tab in index.jsx;
  // FEATURE_EDIT absent -> disable the toggle rather than hide it).
  const featureEditDisabled = !hasPermission('FEATURE_EDIT');

  const {control, register, handleSubmit, reset, setValue} = useForm({
    defaultValues: {
      edge_lock_toggle: feature_customer_edge_lock
    }
  });
  
  const handleShow = () => setShowConfirm(true);
  const handleClose = () => setShowConfirm(false);

  const handleChange = (v) => {
    
    setShowConfirm(true);
  }

  const handleFeatureSettings = async (formData) => {
    const toggleState = !feature_customer_edge_lock;

    const toggle = await featureToggle({variables: {
      feature: {
        feature_code: "EDGE_LOCK",
        customer_enabled: toggleState
      }
    }});

    if(toggle?.errors) {
      error({msg: 'There was an error updating the Edge Lock Settings. Please try again.'});
    } else {
      success({msg: 'Edge Lock Settings updated.'});
    }
  }

  const modalMessage = () => {
    const txt = feature_customer_edge_lock ? 'disabled' : 'enabled';
    return `Edge locking feature will be ${txt} on all SafeCases.`;
  }
  
  return(
    <Form>
      <div className="account-form modal-body">
        <Form.Group>
          <Form.Check
            data-testid="edge-locking-checkbox"
            type="switch"
            id="edge_lock_toggle"
            label="SafeCase Edge Locking"
            disabled={featureEditDisabled}
            onChange={(e) => {
              const checked = e?.target?.checked;
              //onChange(checked)
              handleChange(checked)
            }}
            checked={feature_customer_edge_lock}
          />
        </Form.Group>
        <ConfirmFeatureToggle
          title="Edge Locking"
          showconfirm={showConfirm}
          handleclose={handleClose}
          onChange={handleSubmit(handleFeatureSettings)}
          message={modalMessage()}
        />
      </div>
    </Form>
  )
};

export default compose(
  withAlerts
)(EdgeLockToggle);
